"use strict";

var _interopRequireDefault = require("E:/zkdn_workspace/zhijiao/bjzyjy-mhwz/node_modules/@babel/runtime/helpers/interopRequireDefault.js");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _ObjectForm = _interopRequireDefault(require("@/components/ObjectForm"));
var _news = require("@/api/news/news");
//
//
//
//
//
//
//
var _default = exports.default = {
  components: {
    formIcon: _ObjectForm.default
  },
  data: function data() {
    return {
      formData: {
        rules: {
          newsTypeName: [{
            required: true,
            message: "请输入分类名称",
            trigger: "blur"
          }, {
            min: 1,
            max: 10,
            message: "新闻分类字数推荐在1到10个字符以内",
            trigger: "blur"
          }]
        },
        labelWidth: "120px",
        inline: false,
        labelPosition: "right",
        size: "small",
        formItem: [{
          type: "input",
          label: "分类名称：",
          isDisabled: false,
          placeholder: "请输入分类名称",
          prop: "newsTypeName",
          value: ""
        }]
      }
    };
  },
  methods: {
    submit: function submit(e) {
      var _this = this;
      console.log(e);
      (0, _news.newTypeAdd)({
        businessId: "",
        id: "",
        newsTypeName: e.newsTypeName,
        sort: 0
      }).then(function (res) {
        _this.$message.success("操作成功");
        _this.$router.push("/webSet/webSetNewsType");
      });
    }
  }
};